export const NATIONALITY_OPTIONS = [
  { value: 'Saudi Arabia', labelKey: 'auth.nationalities.saudi_arabia' },
  { value: 'Egypt', labelKey: 'auth.nationalities.egypt' },
  { value: 'India', labelKey: 'auth.nationalities.india' },
  { value: 'Pakistan', labelKey: 'auth.nationalities.pakistan' },
  { value: 'Bangladesh', labelKey: 'auth.nationalities.bangladesh' },
  { value: 'Philippines', labelKey: 'auth.nationalities.philippines' },
  { value: 'Indonesia', labelKey: 'auth.nationalities.indonesia' },
  { value: 'Jordan', labelKey: 'auth.nationalities.jordan' },
  { value: 'Lebanon', labelKey: 'auth.nationalities.lebanon' },
  { value: 'Syria', labelKey: 'auth.nationalities.syria' },
  { value: 'Yemen', labelKey: 'auth.nationalities.yemen' },
  { value: 'Sudan', labelKey: 'auth.nationalities.sudan' },
  { value: 'Morocco', labelKey: 'auth.nationalities.morocco' },
  { value: 'Tunisia', labelKey: 'auth.nationalities.tunisia' },
  { value: 'Algeria', labelKey: 'auth.nationalities.algeria' },
  { value: 'Iraq', labelKey: 'auth.nationalities.iraq' },
  { value: 'Kuwait', labelKey: 'auth.nationalities.kuwait' },
  { value: 'UAE', labelKey: 'auth.nationalities.uae' },
  { value: 'Bahrain', labelKey: 'auth.nationalities.bahrain' },
  { value: 'Qatar', labelKey: 'auth.nationalities.qatar' },
  { value: 'Oman', labelKey: 'auth.nationalities.oman' },
  { value: 'Palestine', labelKey: 'auth.nationalities.palestine' },
  { value: 'Turkey', labelKey: 'auth.nationalities.turkey' },
  { value: 'Afghanistan', labelKey: 'auth.nationalities.afghanistan' },
  { value: 'Sri Lanka', labelKey: 'auth.nationalities.sri_lanka' },
  { value: 'Nepal', labelKey: 'auth.nationalities.nepal' },
  { value: 'Other', labelKey: 'auth.nationalities.other' },
] as const;

export function getNationalityLabelKey(value?: string | null) {
  if (!value) return undefined;
  return NATIONALITY_OPTIONS.find((option) => option.value === value)?.labelKey;
}
